import type { AxiosResponse } from 'axios'
import Server from './service'
import { TOKEN_KEY, getToken } from './token'
import { responseHandle, consoleError, httpErrorStatusHandle, normalizeRequestError } from './error'

import { RequestConfig } from './types'

const service = new Server({
  baseURL: process.env.VUE_APP_BASE_API,
  withCredentials: true,
  xsrfCookieName: 'X-XSRF-TOKEN',
  timeout: 1000 * 60 * 5,
  interceptors: {
    requestInterceptors: config => {
      // 增加来源类型
      // eslint-disable-next-line no-param-reassign
      config.headers['geo-source-type'] = localStorage.getItem('geoMode') || 'inner'
      // 自动携带 token
      const AUTH_TOKEN = getToken()
      if (AUTH_TOKEN && typeof window !== 'undefined') {
        // @ts-ignore
        // eslint-disable-next-line no-param-reassign
        config.headers[TOKEN_KEY] = AUTH_TOKEN
        // eslint-disable-next-line no-param-reassign
        config.headers['x-xsrf-token'] = AUTH_TOKEN
      }
      return config
    },
    responseInterceptors: result => result,
  },
})

export default (config: RequestConfig) => {
  const { method = 'get', repeatRequestCancel = true, errorMessageShow = true } = config
  if (method === 'get' || method === 'GET') {
    // eslint-disable-next-line no-param-reassign
    config.params = config.data
  }
  // 取消重复请求
  if (repeatRequestCancel) {
    service.removePending(config)
    service.addPending(config)
  }

  return service
    .request(config)
    .then(response => responseHandle(<AxiosResponse>response))
    .catch(error => {
      normalizeRequestError(error)
      if (process.env.NODE_ENV !== 'production') consoleError(error)
      if (errorMessageShow) httpErrorStatusHandle(error)
      return Promise.reject(error)
    })
    .finally(() => {
      if (repeatRequestCancel) service.removePending(config)
    })
}

// 取消请求
export const cancelRequest = (url: string | string[]) => {
  return service.cancelRequest(url)
}
// 取消全部请求
export const cancelAllRequest = () => {
  return service.cancelAllRequest()
}
